export enum IAuthModalMode {
  login = 'login',
  signUp = 'signUp',
  welcome = 'welcome',
}
